const ChevronDownIcon = ({
  width = 16,
  height = 8,
  fill = "none",
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 8"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.049 0.292894C14.4953 -0.0976297 15.219 -0.0976296 15.6653 0.292894C16.1116 0.683418 16.1116 1.31658 15.6653 1.70711L8.80812 7.7071C8.37546 8.08568 7.67879 8.09893 7.22775 7.73715L0.370606 2.23715C-0.0946726 1.86396 -0.126104 1.23139 0.300402 0.824275C0.726907 0.417156 1.44984 0.389653 1.91512 0.762846L7.96563 5.61586L14.049 0.292894Z"
      fill={fill}
    />
  </svg>
);

export default ChevronDownIcon;
